import { EmployeeContributionTypeEnum } from '../types/enums';

export interface CalculateMinEmployeeContributionParams {
	employeeContributionRequired?: boolean;
	employeeContributionMinimum?: number;
	employeeContributionType?: string;
	grossAnnualSalary?: number;
}

export function calculateMinEmployeeContribution(
	params: CalculateMinEmployeeContributionParams
): number {
	const { employeeContributionRequired, employeeContributionType, grossAnnualSalary } = params;

	// employeeContributionMinimum puede llegar como STRING del backend. Lo normalizamos a
	// número para no devolver un string (que rompe el slider de Radix: con un `min` string
	// concatena en su cálculo interno y la bolita se dispara al máximo).
	const employeeContributionMinimum = Number(params.employeeContributionMinimum) || 0;

	if (!employeeContributionRequired || !employeeContributionMinimum) return 0;

	if (employeeContributionType === EmployeeContributionTypeEnum.PERCENTAGE) {
		if (!grossAnnualSalary) return 0;
		return Math.ceil((grossAnnualSalary * employeeContributionMinimum) / 100 / 12);
	}

	return employeeContributionMinimum;
}
